export default {
  author: "Meyer Visions",
  hero: {
    subtitle: "Funding the Future.",
    description: "Meyer Visions is a venture capital firm that invests early in founders building fast-growing technology companies.",
    cta: "Browse Companies",
  },
  quote: {
    text: "Our mission is to launch the innovators building companies who share our vision of creating a sustainable, equitable, and rewarding future.",
    authors: [
      {
        name: "Hunter Meyer",
        url: "https://www.linkedin.com/in/HRMeyer"
      },
      {
        name: "Megan Murphy",
        url: "https://www.linkedin.com/in/megandmurphy/"
      }
    ],
    authorTitle: "Founders"
  },
  companies: {
    featured: [
      {
        name: "UpSchool",
        medium: "Education · Gig-Economy",
        summary: "Homeschool Curriculum Marketplace.",
        copy: [
          "Marketplace to find and sell certified homeschool courses and curriculum.",
        ],
        links: {
          color: "#363636",
        },
        images: [
          "/companies/up-school/0.webp",
          "/companies/up-school/1.webp"
        ]
      },
      {
        name: "Backspace",
        medium: "Social · Community · Creative",
        summary: "Build, Connect, and Moneitze Communities.",
        copy: [
          "The social community platform that prioritizes creators connection to their fans.",
        ],
        links: {
          color: "#363636",
          primary: {
            name: "Learn more",
            url: "https://backspacethat.com",
            title: "Open Backspace website"
          }
        },
        images: [
          "/companies/backspace/0.webp",
          "/companies/backspace/1.webp"
        ]
      },
      {
        name: "Next Bolt",
        medium: "Green Energy · Batteries · Infrastructure",
        summary: "The Future of Home Batteries.",
        copy: [
          "Next Bolt is a home battery that powers during the day and charges at night, saving you money reduces emissions.",
        ],
        links: {
          color: "#363636",
          primary: {
            name: "Learn more",
            url: "https://nextthing.tech/",
            title: "Open Next Bolt website"
          }
        },
        images: [
          "/companies/next-bolt/0.webp",
          "/companies/next-bolt/1.webp",
          "/companies/next-bolt/2.webp",
        ]
      },
      {
        name: "SolarGaps",
        medium: "Green Energy · Smart Cities · Social Impact",
        summary: "World's First Smart Solar Blinds.",
        copy: [
          "SolarGaps smart blinds track the sun and generate electricity from its energy. Reducing your energy bill and carbon footprint."
        ],
        links: {
          color: "#363636",
          primary: {
            name: "Learn more",
            url: "https://solargaps.com",
            title: "Open SolarGaps website"
          }
        },
        images: [
          "/companies/solargaps/0.webp",
          "/companies/solargaps/1.webp",
          "/companies/solargaps/2.webp",
          "/companies/solargaps/3.webp",
        ]
      },
      {
        name: "RAD AI",
        medium: "AI · B2B · Software",
        summary: "Marketing AI Platform with an EQ.",
        copy: [
          "We blend the magic of storytelling -- with a mastery of AI -- to create authentic influencer marketing programs.",
        ],
        links: {
          color: "#363636",
          primary: {
            name: "Learn more",
            url: "https://www.radintel.ai/",
            title: "Open RAD AI website"
          }
        },
        images: [
          "/companies/rad-ai/0.webp",
          "/companies/rad-ai/1.webp",
          "/companies/rad-ai/2.webp",
        ]
      },
      {
        name: "Musiversal",
        medium: "Music · B2C · Software",
        summary: "Remote Recording Studio.",
        copy: [
          "Record your songs in real time with 1:1 professional musicians and sound engineers.",
        ],
        links: {
          color: "#363636",
          primary: {
            name: "Learn more",
            url: "https://musiversal.com",
            title: "Open Musiversal website"
          }
        },
        images: [
          "/companies/musiversal/0.webp",
          "/companies/musiversal/1.webp",
        ]
      },
    ],
    // Only supports 0-3 at the moment
    minor: [
      {
        name: "Jr.DevJobs",
        description: "Jobs for junior software developers.",
        link: {
          name: "Visit",
          url: "https://www.jrdevjobs.com",
          title: "Open Jr.DevJobs website"
        }
      },
      {
        name: "MonthlyStash",
        description: "Delivering CBD to the world.",
        link: {
          name: "Visit",
          url: "https://www.monthlystash.com",
          title: "Open MonthlyStash website"
        }
      },
      {
        name: "Coming soon...",
        description: "Your company could be here!",
        link: {
          name: "Contact us",
          url: "mailto:contact@meyervisions.com",
          title: "Contact us via email"
        }
      }
    ]
  },
  footer: {
    tagline: "Meyer Visions · Funding the Future",
    links: [
      {
        title: "Meyer Visions on X",
        url: "https://x.com/MeyerVisions",
        fa: "fa-brands fa-x-twitter"
      },
      {
        title: "Meyer Visions on Facebook",
        url: "https://facebook.com/MeyerVisions",
        fa: "fa-brands fa-facebook"
      },
      {
        title: "Meyer Visions on LinkedIn",
        url: "https://www.linkedin.com/company/MeyerVisions/",
        fa: "fa-brands fa-linkedin"
      }
    ]
  }
}
